import axios from 'axios'

import auth from '../services/auth'

/**
 *============================================================
 * API
 * ===========================================================
 *
 * Initialize the axios instance with an Authorization header.
 * Refreshes expired token before am API request.
 *
 *============================================================
 */
export default {
  /**
   * Creates an axios instance with an access token as authorization header
   * Refreshes token when it is expired.
   *
   */
  http (baseURL) {
    const http = axios.create({ baseURL })

    // Refreshes token before any request
    http.interceptors.request.use(async config => {
      auth.tokenIsExpired() && await auth.refreshToken()

      config.headers.Authorization = `Bearer ${auth.getAccessToken()}`

      return config
    })

    return http
  }
}
